import { render } from "./FitraPage.vue?vue&type=template&id=78f97d0e"
import script from "./FitraPage.vue?vue&type=script&lang=js"
export * from "./FitraPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__